import type { RuleDef } from './rules.js';

export function formatValue(rule: Pick<RuleDef, 'unit'>, v: number): string {
  const n = String(Math.round(v * 10) / 10).replace('.', ',');
  switch (rule.unit) {
    case 'd':
      return `${n} d`;
    case 'dl':
      return `${n} d lab.`;
    case '%':
      return `${n} %`;
    case 'm':
      return `${n} meses`;
    case 're':
      return `${n}ª reapertura`;
    case 'R':
      return `R${n}`;
  }
}

export function formatThresholds(rule: Pick<RuleDef, 'unit' | 'amber' | 'red' | 'inv'>): string {
  const f = (v: number) => formatValue(rule, v);
  return rule.inv
    ? `ámbar ≤ ${f(rule.amber)} · rojo ≤ ${f(rule.red)}`
    : `ámbar ≥ ${f(rule.amber)} · rojo ≥ ${f(rule.red)}`;
}

export const LIGHT_LABEL = { rojo: 'rojo', ambar: 'ámbar', verde: 'verde' } as const;

/** Validación del texto de un acuerdo: debe empezar por un verbo en infinitivo. */
export function validateAgreementText(text: string): string | null {
  const t = text.trim();
  if (!t) return 'Escribe el acuerdo.';
  const first = (t.split(/\s+/)[0] ?? '').toLowerCase();
  if (!/(ar|er|ir|ír)(se|le|lo|la|les|los|las)?$/.test(first))
    return 'Empieza por un verbo en infinitivo: «Escalar», «Enviar», «Llamar»…';
  return null;
}
